<template>
  <b-row>
    <b-col v-if="softwareData.software_image" md="3">
      <img
        :src="softwareData.software_image.download_url"
        :alt="softwareData.software_image.title"
        class="image-item"
      />
    </b-col>
    <b-col md="9" class="content d-flex flex-column align-items-start">
      <h4>{{ this.softwareData.title }}</h4>
      <p class="text-break">{{ this.softwareData.summary }}</p>
      <div class="button-section">
        <router-link :to="this.software_page_path">
          <b-button variant="primary">Read More</b-button>
        </router-link>
        <a
          target="_blank"
          rel="noopener noreferrer"
          v-if="softwareData.repo_url"
          :href="softwareData.repo_url"
        >
          <b-button variant="primary">Download</b-button>
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          v-if="
            softwareData.interactive_demo &&
            softwareData.interactive_demo.waiting_review === false
          "
          :href="'/demos/' + softwareData.interactive_demo.service_name + '/'"
        >
          <b-button variant="primary">Live Demo</b-button>
        </a>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "Software",
  props: ["softwareData"],
  data() {
    return {
      software_page_path: `/software/${this.softwareData.id}`,
    };
  },
};
</script>

<style lang="scss">
.software-item {
  width: 100%;
  overflow: hidden;
}

.image-item {
  width: 90%;

  object-fit: cover !important;
  object-position: center !important;

  @include media-breakpoint-down(sm) {
    margin-bottom: 1em;
  }
}

.button-section {
  display: flex;
  flex-direction: row;
  gap: 1em;

  margin-top: auto;

  @include media-breakpoint-down(sm) {
    flex-direction: column;
  }
}
</style>
